angular.module('picmonicng').directive('communityFactGroup', [
  function () {
    return {
      restrict: 'E',
      templateUrl: '/templates/directives/community-fact-group.html',
      scope: {
        playerService: '=',
        group: '=',
      },
      link: function (scope, element, attrs) {
        scope.$watch(
          function () {
            return scope.group.open;
          },
          function (newVal, oldVal) {
            if (newVal) {
              setTimeout(function () {
                angular.element('.player-sidebar-wrapper').animate(
                  {
                    scrollTop: element[0].offsetTop,
                  },
                  300
                );
              }, 50);
            }
          }
        );
      },
      controller: [
        '$scope',
        '$filter',
        'Picmonics',
        'User',
        '$modal',
        'UserService',
        function ($scope, $filter, Picmonics, User, $modal, UserService) {
          $scope.toggleOpen = function (group) {
            if (!group.open) {
              angular.forEach($scope.playerService.communityFactGroups, function (value, key) {
                value.open = false;
              });
            }

            group.open = !group.open;
          };

          $scope.selectFact = function (fact) {
            $scope.playerService.clearSelectedFact();
            $scope.playerService.audioElement.pause();

            fact.viewed = true;
            if (fact.selected) {
              angular.forEach($scope.playerService.communityFactGroups, function (value, key) {
                angular.forEach(value.facts, function (value2, key2) {
                  value2.selected = false;
                });
              });
              $scope.playerService.currentCommunityFact = {};
            } else {
              angular.forEach($scope.playerService.communityFactGroups, function (value, key) {
                value.open = false;

                angular.forEach(value.facts, function (value2, key2) {
                  value2.selected = false;

                  if (value2 == fact) {
                    value2.selected = true;

                    value.open = true;
                    $scope.playerService.currentCommunityFact = fact;
                  }
                });
              });
            }
          };

          $scope.hideFact = function (fact, $event) {
            $event.stopPropagation();
            User.save({
              resource: 'community_facts',
              resource_id: fact.fact_id,
              is_hidden: 1,
            });

            if (fact == $scope.playerService.currentCommunityFact) {
              $scope.playerService.currentCommunityFact = {};
            }

            fact.is_hidden = 1;
          };

          $scope.hideGroup = function (group, $event) {
            $event.stopPropagation();
            User.save({
              resource: 'community_facts_groups',
              group_name: group.name,
              card_id: $scope.playerService.currentCard.card_id,
              is_hidden: 1,
            });

            group.is_hidden = 1;
          };

          $scope.showCommunityFactDisclaimerModal = function (fact, group, $event) {
            $modal.open({
              templateUrl: '/templates/modals/community-fact-disclaimer.html',
              windowClass: 'community-fact-disclaimer-modal full-screen-modal',
              backdropClass: 'below-nav',
              size: 'md',
              backdrop: 'static',
              keyboard: false,
              scope: $scope,
              controller: [
                '$scope',
                '$modalInstance',
                'UserService',
                function ($scope, $modalInstance, UserService) {
                  $scope.agree = function () {
                    UserService.user.cf_terms_accepted = 1;
                    UserService.user.$update();
                    $scope.addFact(fact, group, $event);

                    $modalInstance.close();
                  };
                },
              ],
            });
          };

          $scope.addFact = function (fact, group, $event) {
            if (!UserService.user.cf_terms_accepted) {
              $scope.showCommunityFactDisclaimerModal(fact, group, $event);
              return;
            }

            $event.stopPropagation();

            group.open = false;
            group.is_added = 1;

            fact.is_added = 1;
            fact.selected = false;

            fact.card_id = $scope.playerService.currentCard.card_id;
            fact.cloned_from_fact_id = fact.fact_id;

            $scope.loading = true;
            Picmonics.cloneFact(fact).$promise.then(function (newfact) {
              $scope.playerService.currentFacts.push(newfact);
              $scope.playerService.selectFact(newfact);
              $scope.loading = false;
              $scope.playerService.initQuiz();
            });
          };
        },
      ],
    };
  },
]);
